export default __webpack_public_path__ + "static/media/G2.90f38113.mp3";